export const notifiContent = {
    1: "Reception want EDIT SUM",
    2: "B.M want EDIT Sum Report",
    3: "Account Branch want EDIT SUM report",
    4: "Result request",
    10: "This Bill have not paid want check it"
}